export const ALL = 'all';

export const ON_REGEX = '^on(.*)';

export const ONCE_REGEX = '^once(.*)';
